import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ClockArrowCircleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="clockArrowCircle" ref={ref} {...props}>
    <path d="M16.53,15.53a.73.73,0,0,1-.53.22.74.74,0,0,1-.53-.22l-3-3a.75.75,0,0,1-.22-.53V8a.75.75,0,0,1,1.5,0v3.69l2.78,2.78A.74.74,0,0,1,16.53,15.53ZM13,2.25a9.71,9.71,0,0,0-9.7,8.86H1.66a.76.76,0,0,0-.68.43.73.73,0,0,0,.1.79l2.34,2.89A.74.74,0,0,0,4,15.5a.72.72,0,0,0,.58-.28l2.35-2.89a.75.75,0,0,0-.58-1.22H4.8A8.25,8.25,0,1,1,7.38,18a.75.75,0,0,0-1,1.09A9.75,9.75,0,1,0,13,2.25Z" />
  </Icon>
)) as IconWithRender;

ClockArrowCircleIcon.displayName = 'ClockArrowCircleIcon';
ClockArrowCircleIcon.renderIcon = (props) => (
  <ClockArrowCircleIcon {...props} />
);
export default ClockArrowCircleIcon;
